<template>
    <div class="video-box" ref="videoBox">
        <video class="video" id="video" :src="this.$store.state.promotional_video" muted controls preload></video>
    </div>
</template>

<script>
export default {
    data() {
        return {
            paused: true
        }
    },
    mounted() {
        let _this=this;
        const video = document.getElementById('video');
        window.addEventListener('scroll', function(){
            if (_this.$refs.videoBox !== undefined && _this.$refs.videoBox.getBoundingClientRect().top < 300) {
                video.play();
                _this.paused = false;
            } else {
                video.pause()
                _this.paused = true;
            }
        });
    }
}
</script>

<style scoped>
.video-box{
    position: relative;
    color: #f9fde4;
    width: 100%;
    margin: 20px 0px;
    text-align: center; 
}
.video-box .video{
    width: 100%;
}
.control{
    position: absolute;
    display: inline-block;
    widows: 80px;
    height: 80px;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/mjwy/home/Video.vue